import React from 'react';
import ReactDOM from 'react-dom';
import { Web3Provider } from '@ethersproject/providers';
import { Web3ReactProvider } from '@web3-react/core';
import { ApolloProvider } from '@apollo/client';
import ReactNotification from 'react-notifications-component';

import './style/index.scss';
import './index.css';
// eslint-disable-next-line
import "swiper/swiper-bundle.min.css";

import * as serviceWorker from './serviceWorker';
import { App } from './pages/App';
import './i18n';
import './style/fontello/css/swapkiwi.css';
import { kiwiClient } from './services/apollo';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getLibrary(provider: any): Web3Provider {
  return new Web3Provider(provider);
}

ReactDOM.render(
  <React.StrictMode>
    <Web3ReactProvider getLibrary={getLibrary}>
      <ApolloProvider client={kiwiClient}>
        <ReactNotification />
        <App />
      </ApolloProvider>
    </Web3ReactProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
